<template>
  <v-container id="calculo-derecho" fluid>
    <v-row>
      <v-col cols="4">
        <v-autocomplete v-model="jugadorSelected" color="gold" :items="jugadores" label="Jugador" return-object item-text="fullName" :readonly="precargado.idJugador !== 0">
          <template v-slot:item="{ attrs, item, on }">
            <v-list-item v-bind="attrs" active-class="gold elevation-4 white--text" class="mx-3 mb-3 v-sheet" elevation="0" v-on="on">
              <v-list-item-content>
                <v-list-item-title v-text="item.fullName" />
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="4">
        <v-select v-model="contratoSelected" color="gold" :items="contratosJugador" label="Contrato" return-object item-text="tipo_contrato.descripcion" :readonly="precargado.idContrato !== 0">
          <template v-slot:item="{ attrs, item, on }">
            <v-list-item v-bind="attrs" active-class="gold elevation-4 white--text" class="mx-3 mb-3 v-sheet" elevation="0" v-on="on">
              <v-list-item-content>
                <v-list-item-title v-text="(item.tipo_contrato.descripcion !== 'Sponsors') ? item.tipo_contrato.descripcion : item.tipo_contrato.descripcion + ' ' + item.sponsor.descripcion" />
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-select>
      </v-col>
      <v-col cols="4">
        <v-select v-model="derechoSelected" color="gold" :items="derechos" label="Derechos" return-object :item-text="nombreDerecho" :readonly="precargado.idDerecho !== 0">
          <template v-slot:item="{ attrs, item, on }">
            <v-list-item v-bind="attrs" active-class="gold elevation-4 white--text" class="mx-3 mb-3 v-sheet" elevation="0" v-on="on">
              <v-list-item-content>
                <v-list-item-title v-text="nombreDerecho(item)" />
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-select>
      </v-col>
    </v-row>
    <v-card v-if="Object.keys(derechoSelected).length !== 0" class="v-card--material pa-3">
      <v-card-text class="px-0 pb-0">
        <v-card-title>
          Cuotas
        </v-card-title>
        <v-row style="overflow: auto; height:400px;">
          <v-col v-for="(itemValue, key) in derechoSelected.detalle_derecho_representante" :key="key" cols="6" md="3" class="pb-1 pt-1">
            <v-card class="mt-2 mb-2">
              <v-col cols="12" class="pb-0 pt-1" :style="[itemValue.saldo === 0 ? colorVerde : colorBlanco]">
                <v-row justify="space-between" class="pl-2">
                  <span style="font-size: 1rem"> Cuota: {{ itemValue.cuota }}
                  </span>
                  <v-checkbox v-show="itemValue.saldo !== 0" v-model="cuotasDerechosSelect" :disabled="bloquear" hide-details color="info" class="shrink mr-0 mt-0 pa-0" :value="itemValue" @change="calcularMontoSelec(itemValue)" />
                </v-row>
              </v-col>
              <v-col cols="12" class="pb-0 pt-1">
                <span style="font-size: 1rem"> Monto: {{ simboloMoneda + ' ' + itemValue.monto }} </span>
              </v-col>
              <v-col cols="12" class="pb-0 pt-1">
                <span style="font-size: 1rem"> Saldo: {{ simboloMoneda + ' ' + itemValue.saldo }} </span>
              </v-col>
              <v-col cols="12" class="pt-1">
                <span style="font-size: 1rem"> Vencimiento: {{ itemValue.vencimiento }} </span>
              </v-col>
            </v-card>
          </v-col>
        </v-row>
        <v-row class="mt-12">
          <v-col align-self="center" cols="2">
            <span>Definir monto personalizado: </span>
          </v-col>
          <v-col cols="2" class="pa-0">
            <v-text-field v-model="totalSeleccionado" color="gold" type="number" step="0.01" :max="deudaTotalDerecho" :prefix="simboloMoneda" label="Total a pagar" :disabled="bloquear" @change="comprobarMonto()" />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
  export default {
    name: 'CalculoDerechos',
    props: {
      mode: {
        type: String,
        default: '',
        required: false,
      },
      precargado: {
        type: Object,
        default: null,
      },
      bloquear: {
        type: Boolean,
        default: false,
      },
      monedas: {
        type: Array,
        default: function () {
          return []
        },
        required: false,
      },
    },
    data () {
      return {
        colorBlanco: 'color: "#ABFD99"',
        colorVerde: 'background-color: #ABFD99',
        jugadorSelected: {
          id: '',
        },
        jugadores: [],
        contratosJugador: [],
        contratoSelected: {},
        derechos: [],
        derechoSelected: {},
        deudaTotalDerecho: 0,
        totalSeleccionado: 0,
        cuotasDerechosSelect: [],
        dataForm: {},
      }
    },
    computed: {
      simboloMoneda () {
        return (this.monedas.length !== 0 && Object.keys(this.derechoSelected).length !== 0) ? this.monedas.find(e => e.id === this.derechoSelected.moneda_id).simbolo : '$'
      },
    },
    watch: {
      jugadorSelected () {
        this.contratoSelected = {}
        this.contratosJugador = []
        if (this.precargado.idJugador !== 0) {
          this.getContrato()
        } else {
          this.getContratosJugador()
        }
      },
      contratoSelected (val) {
        this.derechoSelected = {}
        if (Object.keys(val).length !== 0) {
          this.generarArreglosContratos()
        }
      },
      derechoSelected () {
        this.reiniciarDerecho()
        if (Object.keys(this.derechoSelected).length !== 0 && this.precargado.idDerecho === 0) {
          this.calcularDeudaTotalxDerecho()
          this.$emit('reset')
        }
      },
    },
    created () {
      if (this.mode === 'precargado') {
        this.getJugador()
      } else {
        this.getJugadores()
      }
    },
    methods: {
      enviarPadre () {
        this.dataForm.monto = this.totalSeleccionado
        this.dataForm.cuotasAPagar = this.cuotasDerechosSelect
        this.$emit('montoGenerado', this.dataForm)
      },
      reiniciarDerecho () {
        this.dataForm.moneda_id = (this.derechoSelected) ? this.derechoSelected.moneda_id : 1
        this.dataForm.club_id = (this.derechoSelected) ? this.derechoSelected.club_id : null
        this.dataForm.jugador_id = (this.derechoSelected) ? this.derechoSelected.jugador_id : null
        if (this.precargado.idDerecho === 0) {
          this.cuotasDerechosSelect = []
          this.totalSeleccionado = 0
        }
      },
      generarArreglosContratos: function () {
        this.deudaTotalDerecho = 0
        this.derechos = this.contratoSelected.derecho_representante
        if (this.mode === 'precargado') {
          this.seleccionarDerecho()
          this.calcularDeudaTotalxDerecho()
        }
      },
      seleccionarDerecho () {
        this.derechoSelected = this.derechos.find(e => e.id === this.precargado.idDerecho)
        this.dataForm.club_id = this.derechoSelected.club_id
        this.dataForm.jugador_id = this.derechoSelected.jugador_id
        this.dataForm.moneda_id = this.derechoSelected.moneda_id
        const cuotasFromContrato = this.$store.getters['dep/getCuotas']
        if (cuotasFromContrato.length !== 0) {
          cuotasFromContrato.forEach(e => {
            const aux = this.derechoSelected.detalle_derecho_representante.find(j => j.id === e)
            this.cuotasDerechosSelect.push(aux)
            this.calcularMontoSelec(aux)
          })
        }
      },
      calcularMontoSelec: function (itemValue) {
        if (this.cuotasDerechosSelect.includes(itemValue)) {
          const aux = parseFloat(this.totalSeleccionado) + itemValue.saldo
          this.totalSeleccionado = parseFloat(aux.toFixed(2))
        } else {
          const aux = parseFloat(this.totalSeleccionado) - itemValue.saldo
          this.totalSeleccionado = parseFloat(aux.toFixed(2))
        }
        if (this.totalSeleccionado <= 0) {
          this.totalSeleccionado = 0
        }
        this.enviarPadre()
      },
      calcularDeudaTotalxDerecho () {
        let totalDerecho = 0
        this.derechoSelected.detalle_derecho_representante.forEach(element => {
          totalDerecho += element.saldo
        })
        this.deudaTotalDerecho = totalDerecho
      },
      comprobarMonto () {
        this.totalSeleccionado = parseFloat(this.totalSeleccionado)
        if (this.totalSeleccionado > this.deudaTotalDerecho) {
          this.totalSeleccionado = this.deudaTotalDerecho
          this.$store.commit('toast/show', { tipo: 'info', messages: ['El monto elegido supera la deuda total del derecho seleccionado'] })
        }
        if (this.totalSeleccionado !== 0) {
          this.seleccionarCuotasAutom(this.totalSeleccionado)
        }
        this.enviarPadre()
      },
      seleccionarCuotasAutom (monto) {
        this.cuotasDerechosS = []
        let termino = false
        let i = 0
        let acumulado = 0
        const maxCuotas = this.derechoSelected.detalle_derecho_representante.length
        const arrayAux = []
        while (!termino) {
          if (i < maxCuotas) {
            const montoAsumar = this.derechoSelected.detalle_derecho_representante[i].saldo
            if (montoAsumar !== 0) {
              if ((acumulado + montoAsumar) < monto) {
                acumulado += montoAsumar
                arrayAux.splice(i, 0, this.derechoSelected.detalle_derecho_representante[i])
              } else {
                acumulado += montoAsumar
                arrayAux.splice(i, 0, this.derechoSelected.detalle_derecho_representante[i])
                termino = true
              }
            }
          }
          i += 1
        }
        this.cuotasDerechosSelect = arrayAux
      },
      nombreDerecho: item => 'Derecho: ' + item.id + ' sobre: ' + ((item.club_id !== null) ? 'club' : 'jugador'),
      getJugadores () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/jugador' }).then(response => { this.jugadores = response })
      },
      getJugador () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/jugador/' + this.precargado.idJugador }).then(response => {
          this.jugadorSelected = response
          this.jugadores.push(response)
        })
      },
      getContratosJugador: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/contratos_jugador_derechos/' + this.jugadorSelected.id }).then(response => {
          this.contratosJugador = response
        })
      },
      getContrato: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/contrato_jugador/' + this.precargado.idContrato }).then(response => {
          this.contratoSelected = response
          this.contratosJugador.push(response)
        })
      },
    },
  }
</script>
